import React from "react";
import PropTypes from "prop-types";
import "../../../assets/scss/components/ui/cards/OperatorCard.scss";
import { usePlateWithVehicle } from "../../../hooks/useVehicleQuery";
import UserAvatar from "../avatar/UserAvatar";
import { Link } from "react-router-dom";

const OperatorCard = ({
  userId,
  name,
  lastName,
  personImage,
  documentNumber,
  theme = "dark",
  vehicles = [],
}) => {
  const primaryVehicle = vehicles && vehicles.length > 0 ? vehicles[0] : null;
  const vehiclePlate = primaryVehicle?.plate || "";
  const vehicleType = primaryVehicle?.vehicle_type || "";
  const vehicleColor = primaryVehicle?.color || "";
  const vehicleModel = primaryVehicle?.model || "";

  // Información del trailer si existe
  const hasTrailer = primaryVehicle?.trailer !== null;
  const trailerPlate = hasTrailer ? primaryVehicle?.trailer?.plate : "";

  // Determinar la clase basada en el tema
  const cardClass = `operator-card ${
    theme === "light" ? "theme-light" : "theme-dark"
  }`;

  return (
    <Link to={`/persons/profile/${userId}`} className="card-link">
      <div className={cardClass}>
        <div className="card-header">
          <div className="column first">
            <div className="column first-margenv1">
              {!primaryVehicle ? (
                <div className="vehicle-info no-vehicle">
                  Sin Placa
                </div>
              ) : (
                <div
                  className="vehicle-info with-tooltip"
                  title={`${vehicleType} - ${vehicleModel}`}
                >
                  <div className="vehicle-container">
                    <span className="vehicle-plate-text">{vehiclePlate}</span>
                  </div>
                </div>
              )}
            </div>

            <div className="column first-margen"></div>
          </div>

          <div className="column second">
            <div className="column second-content">
              {hasTrailer && (
                <div
                  className="trailer-info with-tooltip"
                  title="Remolque asignado"
                >
                  <div className="trailer-container">
                    <span className="trailer-plate-text">{trailerPlate}</span>
                  </div>
                </div>
              )}
            </div>
            <div className="column second-margenv2"></div>
            <div className="column second-margenv3"></div>
          </div>
        </div>
        <div className="card-content">
          <div className="image-wrapper">
            <div className="image-border">
              <UserAvatar userId={userId} theme={theme} />
            </div>
          </div>
          <div className="info-wrapper">
            <div className="info">
              <div className="line"></div>
              <span className="text">{name || "Sin nombre"}</span>
            </div>
            <div className="info">
              <div className="line"></div>
              <span className="text">{lastName || "Sin apellido"}</span>
            </div>
            <div className="info">
              <div className="line"></div>
              <span className="text">{documentNumber || "No disponible"}</span>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

OperatorCard.propTypes = {
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  lastName: PropTypes.string,
  personImage: PropTypes.string,
  cellPhone: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  theme: PropTypes.oneOf(["light", "dark"]),
  vehicles: PropTypes.array,
};

export default OperatorCard;
